/**
 * Analytics, GA4 + Yandex Metrica.
 * No-op if env vars are not configured. Loads via dynamic script injection.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const YM_ID = process.env.REACT_APP_YANDEX_METRICA_ID;

function loadScript(src, id) {
  if (document.getElementById(id)) return;
  const s = document.createElement('script');
  s.async = true;
  s.id = id;
  s.src = src;
  document.head.appendChild(s);
}

function initGA() {
  if (!GA_ID) return;
  // GA4 base tag is now embedded directly in /app/frontend/public/index.html
  // (the canonical Google-supplied snippet, so Google's tag verifier picks it
  // up via view-source). The static snippet auto-fires the initial page_view
  // on first load; this React tracker only handles SPA route-change events
  // afterwards. No init is performed here to avoid duplicate config calls.
}

function initYM() {
  if (!YM_ID) return;
  if (document.getElementById('ym-loader')) return;
  // Standard Yandex Metrica snippet
  /* eslint-disable */
  (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
  m[i].l=1*new Date();
  for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
  k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,k.id='ym-loader',a.parentNode.insertBefore(k,a)})
  (window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
  /* eslint-enable */
  window.ym(YM_ID, 'init', { clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: true });
}

const AnalyticsTracker = () => {
  const location = useLocation();
  // Skip the very first page_view, the static gtag snippet in index.html
  // already auto-fires it. Subsequent route changes need manual tracking.
  const isFirstNavRef = useRef(true);

  useEffect(() => {
    initGA();
    initYM();
  }, []);

  useEffect(() => {
    if (isFirstNavRef.current) {
      isFirstNavRef.current = false;
      return;
    }
    const path = location.pathname + location.search;
    if (GA_ID && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    if (YM_ID && window.ym) {
      window.ym(YM_ID, 'hit', path);
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;
